import { render } from "./Skeleton.vue?vue&type=template&id=5017ea60&scoped=true&bindings={\"images\":\"data\"}"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=5017ea60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5017ea60"

export default script